/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { CONTENT_TYPE } from '../../utils/constant';
import { encodeBase64 } from '../../utils/utilityFunctions';
import { CALL_API } from '../middleware';
import {
  AcknowledgeAmlCheckRequestBody,
  AcknowledgeAmlCheckResponseBody,
  ApplicationProps,
  CKYCConsentOtpRes,
  CKYCDataValidationRes,
  ckycResult,
  ConsentEmailApproveRejectRequestBody,
  ConsentEmailApproveRejectResponseBody,
  CopyLinkResponse,
  DataMasters,
  EnablePOARequestBody,
  EnablePOAResponseBody,
  esignApplicationResponse,
  GetDetailsFromPaymentIdRes,
  GetDetailsFromRefIDResponse,
  GetDigilockerDataResponseBody,
  GetDigilockerResponseBody,
  GetOtpForInvestorRequestBody,
  GetOtpForInvestorResponse,
  investmentDetailsAplicationRef,
  InvTokenCompanyRes,
  IsApplicableForPOAResponseBody,
  NonKYCVerifyPanRes,
  PhysicalOnboardingReqBody,
  PostAadharXmlResponse,
  SendConsentEmailRequestBody,
  SendConsentEmailResponseBody,
  SendEmailRequestBody,
  SendOtpRequestBody,
  SendOtpResponseBody,
  SubmitNonKYCApplicationToBSERes,
  VerifyCKYCConsentOtpRes,
  verifyInvestorResponse,
  VerifyOtpRequestBody,
  VerifyOtpResponseBody,
  VerifyPanRequestBody,
  VerifyPanResponseBody,
  VerifyPaymentResponse,
} from '../types/api-types';
import { VERIFY_LOGIN_OTP, VERIFY_LOGIN_OTP_SUCCESS, VERIFY_OTP } from '../types/auth';
import {
  SEND_OTP,
  SEND_OTP_SUCCESS,
  VERIFY_PAN,
  VERIFY_PAN_SUCCESS,
  VERIF_OTP_SUCCESS,
  GET_DETAILS_SUCCESS,
  GET_DETAILS,
  GET_OTP_SUCCESS,
  GET_OTP,
  VERIFY_OTP_INVESTOR_SUCCESS,
  VERIFY_OTP_INVESTOR,
  GET_APPLICATION_WITH_REF_ID_SUCCESS,
  GET_APPLICATION_WITH_REF_ID,
  ESIGN_DOCUMENT_SUCCESS,
  ESIGN_DOCUMENT,
  GET_Investment_Details_Aplication_Ref_SUCCESS,
  GET_Investment_Details_Aplication_Ref,
  ENABLE_POA,
  ENABLE_POA_SUCCESS,
  APPLICABLE_FOR_POA_SUCCESS,
  APPLICABLE_FOR_POA,
  SEND_EMAIL_SUCCESS,
  SEND_EMAIL,
  ACKNOWLEDGE_AML_CHECK_SUCCESS,
  ACKNOWLEDGE_AML_CHECK,
  SEND_CONSENTEMAIL_SUCCESS,
  SEND_CONSENTEMAIL,
  SEND_CONSENTEMAIL_APPROVE_SUCCESS,
  SEND_CONSENTEMAIL_APPROVE,
  SEND_CONSENTEMAIL_REJECT_SUCCESS,
  SEND_CONSENTEMAIL_REJECT,
  GET_APPLICATION_DOWNLOAD_SUCCESS,
  GET_APPLICATION_DOWNLOAD,
  EXPORT_APPLICATIONS_LIST_SUCCESS,
  EXPORT_APPLICATIONS_LIST,
  SEND_BSE_CONSENT_SUCCESS,
  SEND_BSE_CONSENT,
  GET_APPLICATION_TYPES_SUCCESS,
  GET_APPLICATION_TYPES,
  GET_PAYMENT_DETAILS_SUCCESS,
  GET_PAYMENT_DETAILS,
  GET_PAYMENT_OTP_SUCCESS,
  GET_PAYMENT_OTP,
  VERIFY_OTP_PAYMENT_SUCCESS,
  VERIFY_OTP_PAYMENT,
  PHYSICAL_ONBOARDING_SUCCESS,
  PHYSICAL_ONBOARDING,
  GEN_INV_TOKENCOMPANY_SUCCESS,
  GEN_INV_TOKENCOMPANY,
  GET_DIGILOCKER,
  GET_DIGILOCKER_SUCCESS,
  GET_AADHAR_XML_SUCCESS,
  GET_AADHAR_XML,
  GET_DIGILOCKER_DATA_SUCCESS,
  GET_DIGILOCKER_DATA,
  GET_MASTER_SUCCESS,
  GET_MASTER,
  GET_CKYC_CONSENT_OTP_SUCCESS,
  GET_CKYC_CONSENT_OTP,
  GET_CKYC_RECORD_SUCCESS,
  GET_CKYC_RECORD,
  CKYC_DATA_VALIDATION_SUCCESS,
  CKYC_DATA_VALIDATION,
  SUBMIT_NON_KYC_APPLICATION_TO_BSE,
  SUBMIT_NON_KYC_APPLICATION_TO_BSE_SUCCESS,
  NON_KYC_VERIFY_PAN,
  NON_KYC_VERIFY_PAN_SUCCESS,
  GET_COPYLINK_SUCCESS,
  COPY_LINK
} from '../types/onBoarding';

export const verifyPan =
  (body: VerifyPanRequestBody, isInvestorDiyOnboarding: boolean) =>
    async (dispatch: any): Promise<VerifyPanResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: isInvestorDiyOnboarding ? `/onboarding/diy-onboarding/verify-pan` : `/onboarding/onboarding/verify-pan`,
          method: 'POST',
          types: [VERIFY_PAN_SUCCESS, VERIFY_PAN],
          body: {
            payload: encodeBase64(
              JSON.stringify({
                pan: body.pan.toUpperCase(),
                dob: body.dob,
                // kycMethod: body.kycMethod,
                onboardingType: body.onboardingType,
                onboardingVia: body.onboardingVia,
                name: body.name,
                onboardingSubType: body.onboardingSubType,
                isBSEEnabled: body.isBSEEnabled,
                onboardingApplicationType: body.onboardingApplicationType,
                minorName: body.minorName
              })
            ),
          },
        },
      });
    };

export const sendOtp =
  (body: SendOtpRequestBody, isInvestorDiyOnboarding: boolean) =>
    async (dispatch: any): Promise<SendOtpResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: isInvestorDiyOnboarding ? `/onboarding/diy-onboarding/send-otp` : `/onboarding/onboarding/send-otp`,
          method: 'POST',
          types: [SEND_OTP_SUCCESS, SEND_OTP],
          body: { payload: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const verifyOtp =
  (body: VerifyOtpRequestBody, isInvestorDiyOnboarding: boolean) =>
    async (dispatch: any): Promise<VerifyOtpResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: isInvestorDiyOnboarding ? `/onboarding/diy-onboarding/verify-otp` : `/onboarding/onboarding/verify-otp`,
          method: 'POST',
          types: [VERIF_OTP_SUCCESS, VERIFY_OTP],
          body: { payload: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getDetailsWithReferenceId =
  (referenceId: string) =>
    async (dispatch: any): Promise<GetDetailsFromRefIDResponse> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/esign/details/${referenceId}`,
          method: 'GET',
          types: [GET_DETAILS_SUCCESS, GET_DETAILS],
        },
      });
    };

export const getDetailsWithPaymentId =
  (paymentId: string) =>
    async (dispatch: any): Promise<GetDetailsFromPaymentIdRes> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/payment-flow/investor-details/${paymentId}`,
          method: 'GET',
          types: [GET_PAYMENT_DETAILS_SUCCESS, GET_PAYMENT_DETAILS],
        },
      });
    };

export const getOtpForInvestor =
  (referenceId: string) =>
    async (dispatch: any): Promise<GetOtpForInvestorResponse> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/esign/get-otp/${referenceId}`,
          method: 'GET',
          types: [GET_OTP_SUCCESS, GET_OTP],
        },
      });
    };

export const getDigilockerKYC =
  ({ applicationId, token }: { applicationId: string, token: string }) =>
    async (dispatch: any): Promise<GetDigilockerResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/kyc-method/getDigiLockerUri?applicationId=${applicationId}&token=Bearer ${token}`,
          method: 'GET',
          types: [GET_DIGILOCKER_SUCCESS, GET_DIGILOCKER],
        },
      });
    };

export const getDigilockerData =
  (body: { code: string, state: string }) =>
    async (dispatch: any): Promise<GetDigilockerDataResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/kyc-method/digiLocker/data`,
          method: 'POST',
          types: [GET_DIGILOCKER_DATA_SUCCESS, GET_DIGILOCKER_DATA],
          body,
          isPolling: true,
          pollingCount: 5,
          pollingTime: 10000
        },
      });
    };

export const postAadharXml =
  (body: any) =>
    async (dispatch: any): Promise<PostAadharXmlResponse> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/kyc-method/fetchAdhaarXmlData`,
          method: 'POST',
          types: [GET_AADHAR_XML_SUCCESS, GET_AADHAR_XML],
          body: body,
        },
      });
    };

export const getOtpForPaymentFlow =
  (paymentId: string) =>
    async (dispatch: any): Promise<GetOtpForInvestorResponse> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/payment-flow/get-otp/${paymentId}`,
          method: 'GET',
          types: [GET_PAYMENT_OTP_SUCCESS, GET_PAYMENT_OTP],
        },
      });
    };

export const verifyOtpForInvestor =
  (referenceId: string, body: GetOtpForInvestorRequestBody) =>
    async (dispatch: any): Promise<verifyInvestorResponse> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/esign/verify-otp/${referenceId}`,
          method: 'POST',
          types: [VERIFY_OTP_INVESTOR_SUCCESS, VERIFY_OTP_INVESTOR],
          body: { payload: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const verifyOtpForPayment =
  (paymentId: string, body: GetOtpForInvestorRequestBody) =>
    async (dispatch: any): Promise<VerifyPaymentResponse> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/payment-flow/verify-otp/${paymentId}`,
          method: 'POST',
          types: [VERIFY_OTP_PAYMENT_SUCCESS, VERIFY_OTP_PAYMENT],
          body: { payload: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getInvestorTokenWithCompany =
  (body: { clientCode: string }) =>
    async (dispatch: any): Promise<InvTokenCompanyRes> => {
      return await dispatch({
        [CALL_API]: {
          url: `/users/users/generate-investor-token-with-company`,
          method: 'POST',
          types: [GEN_INV_TOKENCOMPANY_SUCCESS, GEN_INV_TOKENCOMPANY],
          body,
        },
      });
    };

export const getApplicationDetailsWithRefId =
  (referenceId: string) =>
    async (dispatch: any): Promise<ApplicationProps> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/esign/application-details/${referenceId}`,
          method: 'GET',
          types: [GET_APPLICATION_WITH_REF_ID_SUCCESS, GET_APPLICATION_WITH_REF_ID],
        },
      });
    };

export const esignApplication =
  (referenceId: string) =>
    async (dispatch: any): Promise<esignApplicationResponse> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/esign/sign/${referenceId}`,
          method: 'POST',
          types: [ESIGN_DOCUMENT_SUCCESS, ESIGN_DOCUMENT],
        },
      });
    };

export const ApplicationRefs =
  (applicationId: string | number) =>
    async (dispatch: any): Promise<investmentDetailsAplicationRef> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/esign/get-referenceids/${applicationId}`,
          method: 'GET',
          types: [
            GET_Investment_Details_Aplication_Ref_SUCCESS,
            GET_Investment_Details_Aplication_Ref,
          ],
        },
      });
    };

export const EnablePOA =
  (body: EnablePOARequestBody) =>
    async (dispatch: any): Promise<EnablePOAResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/onboarding/enable-poa`,
          method: 'POST',
          types: [ENABLE_POA_SUCCESS, ENABLE_POA],
          body,
        },
      });
    };

export const IsApplicableForPOA =
  () =>
    async (dispatch: any): Promise<IsApplicableForPOAResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/amc/applicable-for-power-of-attorney`,
          method: 'GET',
          types: [APPLICABLE_FOR_POA_SUCCESS, APPLICABLE_FOR_POA],
        },
      });
    };

export const SendEmail =
  (body: SendEmailRequestBody) =>
    async (dispatch: any): Promise<VerifyOtpResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/onboarding/get-non-individual-application-token`,
          method: 'POST',
          types: [SEND_EMAIL_SUCCESS, SEND_EMAIL],
          body: { payload: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const physicalOnboarding =
  (body: PhysicalOnboardingReqBody) =>
    async (dispatch: any): Promise<VerifyOtpResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/onboarding/get-physical-onboarding-application-token`,
          method: 'POST',
          types: [PHYSICAL_ONBOARDING_SUCCESS, PHYSICAL_ONBOARDING],
          body,
        },
      });
    }

export const AcknowledgeAmlCheck =
  (body: AcknowledgeAmlCheckRequestBody) =>
    async (dispatch: any): Promise<AcknowledgeAmlCheckResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/onboarding/acknowledge-aml-check`,
          method: 'POST',
          types: [ACKNOWLEDGE_AML_CHECK_SUCCESS, ACKNOWLEDGE_AML_CHECK],
          body,
        },
      });
    };

export const sendConsentEmail =
  (body: SendConsentEmailRequestBody) =>
    async (dispatch: any): Promise<SendConsentEmailResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/onboarding/send-consent-email`,
          method: 'POST',
          types: [SEND_CONSENTEMAIL_SUCCESS, SEND_CONSENTEMAIL],
          body,
        },
      });
    };

export const approveConsentEmail =
  (body: ConsentEmailApproveRejectRequestBody) =>
    async (dispatch: any): Promise<ConsentEmailApproveRejectResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/onboarding-consent/approve`,
          method: 'POST',
          types: [SEND_CONSENTEMAIL_APPROVE_SUCCESS, SEND_CONSENTEMAIL_APPROVE],
          body,
        },
      });
    };

export const rejectConsentEmail =
  (body: ConsentEmailApproveRejectRequestBody) =>
    async (dispatch: any): Promise<ConsentEmailApproveRejectResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/onboarding-consent/reject`,
          method: 'POST',
          types: [SEND_CONSENTEMAIL_REJECT_SUCCESS, SEND_CONSENTEMAIL_REJECT],
          body,
        },
      });
    };

export const ApplicationDownload =
  (applicationId: string) =>
    async (dispatch: any): Promise<any> => {
      return await dispatch({
        [CALL_API]: {
          url: `/pdf/onboarding-application/pdf/${applicationId}`,
          method: 'GET',
          types: [GET_APPLICATION_DOWNLOAD_SUCCESS, GET_APPLICATION_DOWNLOAD],
          contentType: CONTENT_TYPE.PDF,
        },
      });
    };

export const exportApplicationsList =
  () =>
    async (dispatch: any): Promise<any> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/downloadApplicationData`,
          method: 'GET',
          types: [EXPORT_APPLICATIONS_LIST_SUCCESS, EXPORT_APPLICATIONS_LIST],
          contentType: CONTENT_TYPE.EXCEL,
        },
      });
    };

export const BseConsent =
  (body: { clientCodeActivatedInBse: boolean }, applicationId: string) =>
    async (dispatch: any): Promise<ApplicationProps> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/applications/bseClientCodeActivationStatus/${applicationId}`,
          method: 'POST',
          types: [SEND_BSE_CONSENT_SUCCESS, SEND_BSE_CONSENT],
          body,
        },
      });
    };

export const getApplicationTypes =
  () =>
    async (dispatch: any): Promise<{ code: string; description: string }[]> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/onboarding/get-application-types',
          method: 'GET',
          types: [GET_APPLICATION_TYPES_SUCCESS, GET_APPLICATION_TYPES],
        },
      });
    };


export const getDataMasters =
  (body?: { category?: string, parent?: string }) =>
    async (dispatch: any): Promise<DataMasters> => {
      const { category, parent } = body || {};
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/dashboard/get-additional-master${category ? `?category=${category}&parent=${parent}` : ''}`,
          method: 'GET',
          types: [GET_MASTER_SUCCESS, GET_MASTER],
        },
      });
    };

//kyc-method/get-ckyc-consent-otp/:applicationId

export const getCKYCConsentOtp =
  (body?: { applicationId: string }) =>
    async (dispatch: any): Promise<CKYCConsentOtpRes> => {
      const { applicationId } = body || {};
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/kyc-method/get-ckyc-consent-otp/${applicationId}`,
          method: 'GET',
          types: [GET_CKYC_CONSENT_OTP_SUCCESS, GET_CKYC_CONSENT_OTP],
        },
      });
    };


export const verifyCKYCConsentOtp =
  (body?: { applicationId: string, otp: string }) =>
    async (dispatch: any): Promise<VerifyCKYCConsentOtpRes> => {
      const { applicationId, otp } = body || {};
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/kyc-method/get-ckyc-record`,
          method: 'POST',
          types: [GET_CKYC_RECORD_SUCCESS, GET_CKYC_RECORD],
          body: { applicationId, otp },
        },
      });
    };


export const postCKYCDataValidation =
  (body?: { applicationId: string, valid?: string, address?: ckycResult, sentToRM?: boolean }) =>
    async (dispatch: any): Promise<CKYCDataValidationRes> => {
      const { applicationId, valid = '', address = {}, sentToRM = false } = body || {};
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/applications/ckyc-data-validation`,
          method: 'POST',
          types: [CKYC_DATA_VALIDATION_SUCCESS, CKYC_DATA_VALIDATION],
          body: { applicationId, valid, address, sentToRM },
        },
      });
    };

export const NonKYCVerifyPan =
  (body?: { applicationId: string, applicantId: string, dateOfBirth: string, name: string, panNo: string }) =>
    async (dispatch: any): Promise<NonKYCVerifyPanRes> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/onboarding/non-kyc-verify-pan`,
          method: 'POST',
          types: [NON_KYC_VERIFY_PAN_SUCCESS, NON_KYC_VERIFY_PAN],
          body: { payload: encodeBase64(JSON.stringify(body)) },
        },
      });
    };


export const SubmitNonKYCApplicationToBSE =
  (body: { applicationId: string }) =>
    async (dispatch: any): Promise<SubmitNonKYCApplicationToBSERes> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/applications/send-non-kyc-application-to-bse/${body.applicationId}`,
          method: 'POST',
          types: [SUBMIT_NON_KYC_APPLICATION_TO_BSE_SUCCESS, SUBMIT_NON_KYC_APPLICATION_TO_BSE],
        },
      });
    };


export const CopyLink =
  (body: { applicationId: string, applicantId: string | any }) => {
    return async (dispatch: any): Promise<CopyLinkResponse> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/account-consent/investor-consent-link/${body.applicationId}/applicantId/${body.applicantId}`,
          method: 'GET',
          types: [COPY_LINK, GET_COPYLINK_SUCCESS]
        }
      })
    }
  }